export default __webpack_public_path__ + "static/media/girl.6794a9f1.png";